import classnames from 'classnames/bind'
import React, { HTMLAttributes } from 'react'
import { useTranslation } from 'next-i18next'

// Components
import Image from '@/components/common/Image'

// Libs
import useI18n from '@/hooks/useI18n'
import { getCompanyBrandName, getCompanyNameDefault } from '@/components/pages/Terms/methods/company'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const CompanyInfo = () => {
  const { t } = useTranslation()
  const { isOverseaUser } = useI18n()

  return (
    <div className={cx('company-info__content')}>
      <div className={cx('company-info__content__name')}>{getCompanyNameDefault(isOverseaUser, t)}</div>
      {!isOverseaUser && <div className={cx('company-info__content__details', 'tax-number')}>{t('Common_Tax_ID', { taxId: '94059616' })}</div>}
      {!isOverseaUser && <div className={cx('company-info__content__details', 'phone')}>(02)3365-9988</div>}
      {!isOverseaUser && <div className={cx('company-info__content__details', 'email')}>shopservice@tutorabcshop.com</div>}
      <div className={cx('company-info__content__details')}>Copyright© {getCompanyBrandName(isOverseaUser)}</div>
    </div>
  )
}

const FooterCompanyInfo = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cx('company-info', className)} {...props}>
      <div className={cx('logo')}>
        <Image
          src={'/images/svg/logo-black.svg'}
          fill
          alt={'TutorABC Shop'}
          style={{
            width: '100%',
          }}
        />
      </div>
      <CompanyInfo />
    </div>
  )
}

export default FooterCompanyInfo
